<template>
  <svg
    class="svg-icon-pack"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <symbol viewBox="0 0 16 16" id="icon--lightbulb">
      <defs>
        <clipPath id="clip318_215117">
          <rect
            id="LightbulbAlt"
            width="16.000000"
            height="16.000000"
            fill="white"
            fill-opacity="0"
          />
        </clipPath>
      </defs>
      <rect
        id="LightbulbAlt"
        width="16.000000"
        height="16.000000"
        fill="#FFFFFF"
        fill-opacity="0"
      />
      <g clip-path="url(#clip318_215117)">
        <path
          id="Union"
          d="M12.09 8.16C11.42 9.29 10.66 10.44 10.66 11.75L10.66 11.99L10.66 12.66C10.66 13.77 9.77 14.66 8.66 14.66L7.33 14.66C6.22 14.66 5.33 13.77 5.33 12.66L5.33 11.99L5.33 11.75C5.33 10.44 4.57 9.29 3.9 8.16C3.54 7.53 3.33 6.81 3.33 5.99C3.33 3.42 5.42 1.33 8 1.33C10.57 1.33 12.66 3.42 12.66 5.99C12.66 6.81 12.45 7.53 12.09 8.16ZM5.33 11.99L8 11.99L10.66 11.99M8 11.99L8 9.33"
          stroke="currentColor"
          stroke-opacity="1.000000"
          stroke-width="2.000000"
          stroke-linecap="round"
        />
      </g>
    </symbol>
    <symbol viewBox="0 0 24 24" id="icon--sun">
      <defs>
        <clipPath id="clip252_15978">
          <rect
            id="Sun"
            width="24.000000"
            height="24.000000"
            fill="white"
            fill-opacity="0"
          />
        </clipPath>
      </defs>
      <rect
        id="Sun"
        width="24.000000"
        height="24.000000"
        fill="#FFFFFF"
        fill-opacity="0"
      />
      <g clip-path="url(#clip252_15978)">
        <path
          id="Icon"
          d="M12 2L12 4M12 20L12 22M4 12L2 12M6.31 6.31L4.89 4.89M17.68 6.31L19.1 4.89M6.31 17.69L4.89 19.1M17.68 17.69L19.1 19.1M22 12L20 12M12 17C9.23 17 7 14.76 7 12C7 9.23 9.23 7 12 7C14.76 7 17 9.23 17 12C17 14.76 14.76 17 12 17Z"
          stroke="currentColor"
          stroke-opacity="1.000000"
          stroke-width="2.000000"
          stroke-linejoin="round"
          stroke-linecap="round"
        />
      </g>
    </symbol>
    <symbol viewBox="0 0 22 15.0005" id="icon--sun-night">
      <defs />
      <path
        id="Union"
        d="M11 0C11.55 0 12 0.44 12 1L12 3C12 3.55 11.55 4 11 4C10.44 4 10 3.55 10 3L10 1C10 0.44 10.44 0 11 0ZM3.19 3.19C3.58 2.8 4.21 2.8 4.6 3.19L6.02 4.6C6.41 4.99 6.41 5.63 6.02 6.02C5.63 6.41 4.99 6.41 4.6 6.02L3.19 4.6C2.8 4.21 2.8 3.58 3.19 3.19ZM18.8 3.19C19.19 3.58 19.19 4.21 18.8 4.6L17.39 6.02C17 6.41 16.36 6.41 15.97 6.02C15.58 5.63 15.58 4.99 15.97 4.6L17.39 3.19C17.78 2.8 18.41 2.8 18.8 3.19ZM11 7C8.79 7 7 8.79 7 11C7 11.06 7 11.13 7 11.19C7.03 11.85 7.22 12.46 7.53 13L14.46 13C14.77 12.45 14.96 11.83 14.99 11.16C14.99 11.11 15 11.05 15 11C15 8.79 13.2 7 11 7ZM2 15C1.44 15 1 14.55 1 14C1 13.44 1.44 13 2 13L5.34 13C5.18 12.56 5.08 12.1 5.03 11.63C5.01 11.42 5 11.21 5 11C5 7.68 7.68 5 11 5C14.31 5 17 7.68 17 11C17 11.26 16.98 11.51 16.95 11.76C16.93 11.91 16.9 12.05 16.87 12.19C16.82 12.47 16.75 12.74 16.65 13L20 13C20.55 13 21 13.44 21 14C21 14.55 20.55 15 20 15L2 15ZM0 11C0 10.44 0.44 10 1 10L3 10C3.55 10 4 10.44 4 11C4 11.55 3.55 12 3 12L1 12C0.44 12 0 11.55 0 11ZM18 11C18 10.44 18.44 10 19 10L21 10C21.55 10 22 10.44 22 11C22 11.55 21.55 12 21 12L19 12C18.44 12 18 11.55 18 11Z"
        fill="currentColor"
        fill-opacity="1.000000"
        fill-rule="evenodd"
      />
    </symbol>
    <symbol viewBox="0 0 16 16" id="icon--thermometer">
      <defs>
        <clipPath id="clip318_215156">
          <rect
            id="Property 1=Default"
            width="16.000000"
            height="16.000000"
            fill="white"
            fill-opacity="0"
          />
        </clipPath>
      </defs>
      <rect
        id="Property 1=Default"
        width="16.000000"
        height="16.000000"
        fill="#FFFFFF"
        fill-opacity="0"
      />
      <g clip-path="url(#clip318_215156)">
        <path
          id="Vector"
          d="M11 8.66L11 3.66C11 2.87 10.68 2.1 10.12 1.54C9.55 0.98 8.79 0.66 8 0.66C7.2 0.66 6.44 0.98 5.87 1.54C5.31 2.1 5 2.87 5 3.66L5 8.66C4.53 9.18 4.22 9.82 4.08 10.5C3.94 11.18 3.98 11.89 4.19 12.55C4.41 13.21 4.79 13.81 5.31 14.27C5.83 14.74 6.45 15.07 7.14 15.22C7.42 15.28 7.71 15.32 8 15.33C8.77 15.33 9.53 15.11 10.18 14.69C10.83 14.27 11.34 13.68 11.66 12.97C11.98 12.26 12.08 11.48 11.97 10.72C11.85 9.95 11.51 9.24 11 8.66ZM9.66 13.38C9.13 13.85 8.44 14.09 7.73 14.04C7.02 14 6.36 13.68 5.89 13.15C5.42 12.62 5.18 11.92 5.22 11.21C5.26 10.51 5.58 9.85 6.12 9.38C6.18 9.31 6.23 9.24 6.26 9.16C6.3 9.08 6.31 8.99 6.31 8.9L6.31 3.66C6.31 3.22 6.49 2.8 6.8 2.48C7.12 2.17 7.54 2 7.98 2C8.42 2 8.85 2.17 9.16 2.48C9.47 2.8 9.65 3.22 9.65 3.66L9.65 8.96C9.65 9.04 9.67 9.13 9.7 9.21C9.74 9.29 9.79 9.37 9.85 9.43C10.12 9.69 10.33 10.01 10.47 10.36C10.61 10.71 10.68 11.09 10.66 11.47C10.64 11.85 10.54 12.22 10.37 12.56C10.2 12.89 9.96 13.19 9.66 13.43L9.66 13.38ZM8.66 10.18L8.66 8.33C8.66 8.15 8.59 7.98 8.47 7.86C8.34 7.73 8.17 7.66 8 7.66C7.82 7.66 7.65 7.73 7.52 7.86C7.4 7.98 7.33 8.15 7.33 8.33L7.33 10.18C7.13 10.3 6.96 10.47 6.84 10.67C6.73 10.87 6.66 11.1 6.66 11.33C6.66 11.68 6.8 12.02 7.05 12.27C7.3 12.52 7.64 12.66 8 12.66C8.35 12.66 8.69 12.52 8.94 12.27C9.19 12.02 9.33 11.68 9.33 11.33C9.33 11.1 9.26 10.87 9.15 10.67C9.03 10.47 8.86 10.3 8.66 10.18Z"
          fill="currentColor"
          fill-opacity="1.000000"
          fill-rule="nonzero"
        />
      </g>
    </symbol>
  </svg>
</template>
